import { render, staticRenderFns } from "./EditForms.vue?vue&type=template&id=5e49d9a5&scoped=true&"
import script from "./EditForms.vue?vue&type=script&lang=js&"
export * from "./EditForms.vue?vue&type=script&lang=js&"
import style0 from "./EditForms.vue?vue&type=style&index=0&id=5e49d9a5&scoped=true&lang=scss&"
import style1 from "./EditForms.vue?vue&type=style&index=1&id=5e49d9a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e49d9a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e49d9a5')) {
      api.createRecord('5e49d9a5', component.options)
    } else {
      api.reload('5e49d9a5', component.options)
    }
    module.hot.accept("./EditForms.vue?vue&type=template&id=5e49d9a5&scoped=true&", function () {
      api.rerender('5e49d9a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/EditForms.vue"
export default component.exports